import userAgentUtils from "@/common/utils/userAgent";
import { OS } from "@/common/constants/device";

export interface Font {
    label: string;
    value: string;
    isCursive?: boolean;
}

const windowsFonts: Font[] = [
    // 中文字体
    { label: '微软雅黑 (Microsoft YaHei)', value: 'Microsoft YaHei' },
    { label: '宋体 (SimSun)', value: 'SimSun' },
    { label: '黑体 (SimHei)', value: 'SimHei' },
    { label: '华文细黑 (STXihei)', value: 'STXihei' },
    { label: '华文楷体 (STKaiti)', value: 'STKaiti' },
    { label: '华文仿宋 (STFangsong)', value: 'STFangsong' },
    { label: '华文宋体 (STSong)', value: 'STSong' },
    { label: '华文中宋 (STZhongsong)', value: 'STZhongsong' },
    // 英文字体
    { label: 'Arial', value: 'Arial' },
    { label: 'Verdana', value: 'Verdana' },
    { label: 'Tahoma', value: 'Tahoma' },
    { label: 'Trebuchet MS', value: 'Trebuchet MS' },
    { label: 'Segoe UI', value: 'Segoe UI' },
    { label: 'Times New Roman', value: 'Times New Roman' },
    { label: 'Georgia', value: 'Georgia' },
    { label: 'Garamond', value: 'Garamond' },
    { label: 'Courier New', value: 'Courier New' },
    { label: 'Consolas', value: 'Consolas' },
    // 英文手写字体
    { label: 'Comic Sans MS', value: 'Comic Sans MS', isCursive: true },
    { label: 'Segoe Script', value: 'Segoe Script', isCursive: true },
    { label: 'Segoe Print', value: 'Segoe Print', isCursive: true },
    { label: 'Lucida Handwriting', value: 'Lucida Handwriting', isCursive: true },
    // 中文手写字体
    { label: '楷体 (KaiTi)', value: 'KaiTi', isCursive: true },
    { label: '仿宋 (FangSong)', value: 'FangSong', isCursive: true },
];

const macOSFonts: Font[] = [
    // 中文字体
    { label: '苹方 (PingFang SC)', value: 'PingFang SC' },
    { label: '华文黑体 (Heiti SC)', value: 'Heiti SC' },
    { label: '宋体 (Songti SC)', value: 'Songti SC' },
    { label: '华文仿宋 (STFangsong)', value: 'STFangsong' },
    { label: '华文楷体 (STKaiti)', value: 'STKaiti' },
    { label: '冬青黑体 (Hiragino Sans GB)', value: 'Hiragino Sans GB' },
    { label: '华文细黑 (STXihei)', value: 'STXihei' },
    { label: '华文中宋 (STZhongsong)', value: 'STZhongsong' },
    // 英文字体
    { label: 'Times New Roman', value: 'Times New Roman' },
    { label: 'Helvetica', value: 'Helvetica' },
    { label: 'Helvetica Neue', value: 'Helvetica Neue' },
    { label: 'San Francisco', value: 'San Francisco' },
    { label: 'Arial', value: 'Arial' },
    { label: 'Verdana', value: 'Verdana' },
    { label: 'Geneva', value: 'Geneva' },
    { label: 'Gill Sans', value: 'Gill Sans' },
    { label: 'Times', value: 'Times' },
    { label: 'Georgia', value: 'Georgia' },
    { label: 'Baskerville', value: 'Baskerville' },
    { label: 'Palatino', value: 'Palatino' },
    { label: 'Courier', value: 'Courier' },
    { label: 'Menlo', value: 'Menlo' },
    { label: 'Monaco', value: 'Monaco' },
    // 英文手写字体
    { label: 'Apple Chancery', value: 'Apple Chancery', isCursive: true },
    { label: 'Marker Felt', value: 'Marker Felt', isCursive: true },
    { label: 'Noteworthy', value: 'Noteworthy', isCursive: true },
    { label: 'Zapfino', value: 'Zapfino', isCursive: true },
    { label: 'Snell Roundhand', value: 'Snell Roundhand', isCursive: true },
    // 中文手写字体
    { label: 'Hannotate简体中文', value: 'Hannotate SC', isCursive: true },
    { label: 'HanziPen简体中文', value: 'HanziPen SC', isCursive: true },
];

const linuxFonts: Font[] = [
    // 英文字体
    { label: 'DejaVu Sans', value: 'DejaVu Sans' },
    { label: 'Liberation Sans', value: 'Liberation Sans' },
    { label: 'Ubuntu', value: 'Ubuntu' },
    { label: 'Noto Sans', value: 'Noto Sans' },
    { label: 'DejaVu Serif', value: 'DejaVu Serif' },
    { label: 'Liberation Serif', value: 'Liberation Serif' },
    { label: 'Courier New', value: 'Courier New' },
    { label: 'DejaVu Sans Mono', value: 'DejaVu Sans Mono' },
    { label: 'Liberation Mono', value: 'Liberation Mono' },
    { label: 'Ubuntu Mono', value: 'Ubuntu Mono' },
    // 中文字体
    { label: '文泉驿微米黑 (WenQuanYi Micro Hei)', value: 'WenQuanYi Micro Hei' },
    { label: '文泉驿正黑 (WenQuanYi Zen Hei)', value: 'WenQuanYi Zen Hei' },
    { label: '文泉驿等宽正黑 (WenQuanYi Zen Hei Mono)', value: 'WenQuanYi Zen Hei Mono' },
    { label: '思源黑体 (Noto Sans CJK SC)', value: 'Noto Sans CJK SC' },
    { label: '思源宋体 (Noto Serif CJK SC)', value: 'Noto Serif CJK SC' },
    { label: '霞鹜文楷 (LXGW WenKai)', value: 'LXGW WenKai' },
    { label: '宋体 (SimSun)', value: 'SimSun' },
    { label: '黑体 (SimHei)', value: 'SimHei' }
];

const androidFonts = [
    // 中文字体
    { label: '思源黑体 (Noto Sans CJK SC)', value: 'Noto Sans CJK SC' },
    { label: '思源宋体 (Noto Serif CJK SC)', value: 'Noto Serif CJK SC' },
    { label: 'Droid Sans Fallback', value: 'Droid Sans Fallback' },
    { label: '华文黑体 (STHeiti)', value: 'STHeiti' },
    { label: '楷体 (KaiTi)', value: 'KaiTi' },
    { label: '仿宋 (FangSong)', value: 'FangSong' },
    { label: '宋体 (SimSun)', value: 'SimSun' },
    { label: '黑体 (SimHei)', value: 'SimHei' },

    // 英文字体
    { label: 'Roboto', value: 'Roboto' },
    { label: 'Arial', value: 'Arial' },
    { label: 'Verdana', value: 'Verdana' },
    { label: 'Tahoma', value: 'Tahoma' },
    { label: 'Trebuchet MS', value: 'Trebuchet MS' },
    { label: 'Times New Roman', value: 'Times New Roman' },
    { label: 'Georgia', value: 'Georgia' },
    { label: 'Garamond', value: 'Garamond' },
    { label: 'Courier New', value: 'Courier New' },
    { label: 'Consolas', value: 'Consolas' },

    // 英文手写字体
    { label: 'Dancing Script', value: 'Dancing Script', isCursive: true },
    { label: 'Pacifico', value: 'Pacifico', isCursive: true },
    { label: 'Lobster', value: 'Lobster', isCursive: true },
    { label: 'Indie Flower', value: 'Indie Flower', isCursive: true },

    // 中文手写字体
    { label: '翩翩体 (ZCOOL QingKe HuangYou)', value: 'ZCOOL QingKe HuangYou', isCursive: true },
    { label: '手札体 (Ma Shan Zheng)', value: 'Ma Shan Zheng', isCursive: true },
    { label: '硬笔行书 (ZCOOL XiaoWei)', value: 'ZCOOL XiaoWei', isCursive: true },
];

const iosFonts = [
    // 中文字体
    { label: '苹方 (PingFang SC)', value: 'PingFang SC' },
    { label: '冬青黑体 (Hiragino Sans GB)', value: 'Hiragino Sans GB' },
    { label: '华文黑体 (STHeiti)', value: 'STHeiti' },
    { label: '楷体 (Kaiti SC)', value: 'Kaiti SC' },
    { label: '宋体 (Songti SC)', value: 'Songti SC' },
    { label: '仿宋 (FangSong)', value: 'FangSong' },

    // 英文字体
    { label: 'San Francisco', value: 'San Francisco' },
    { label: 'Helvetica', value: 'Helvetica' },
    { label: 'Helvetica Neue', value: 'Helvetica Neue' },
    { label: 'Arial', value: 'Arial' },
    { label: 'Verdana', value: 'Verdana' },
    { label: 'Tahoma', value: 'Tahoma' },
    { label: 'Trebuchet MS', value: 'Trebuchet MS' },
    { label: 'Times New Roman', value: 'Times New Roman' },
    { label: 'Georgia', value: 'Georgia' },
    { label: 'Courier New', value: 'Courier New' },
    { label: 'Menlo', value: 'Menlo' },

    // 英文手写字体
    { label: 'Snell Roundhand', value: 'Snell Roundhand', isCursive: true },
    { label: 'Bradley Hand', value: 'Bradley Hand', isCursive: true },
    { label: 'Marker Felt', value: 'Marker Felt', isCursive: true },
    { label: 'Chalkboard SE', value: 'Chalkboard SE', isCursive: true },

    // 中文手写字体
    { label: '翩翩体 (HanziPen SC)', value: 'HanziPen SC', isCursive: true },
    { label: '硬笔行书 (ZCOOL XiaoWei)', value: 'ZCOOL XiaoWei', isCursive: true },
];

const thirdFonts: Font[] = [
    // 第三方手写英文字体
    { label: 'Allura', value: 'Allura' },
    { label: 'Arizonia', value: 'Arizonia' },
    { label: 'Italianno', value: 'Italianno' },
    { label: 'LoveLight', value: 'LoveLight' },
    { label: 'Norican', value: 'Norican' },
    { label: 'PinyonScript', value: 'PinyonScript' },
    { label: 'Qwigley', value: 'Qwigley' },
]

export function getFonts() {
    const platform = userAgentUtils.getOS();
    if (platform === OS.Android) {
        return androidFonts;
    }
    if (platform === OS.iOS) {
        return iosFonts;
    }
    if (platform === OS.Windows) {
        return windowsFonts;
    }
    if (platform === OS.MacOS) {
        return macOSFonts;
    }
    if (platform === OS.Linux) {
        return linuxFonts;
    }
    return windowsFonts;
}

export function getDefaultFontName() {
    return getFonts()[0].value;
}